export default {"src":"/_next/static/media/arrow_down.a24f30e8.svg","height":10,"width":19,"blurWidth":0,"blurHeight":0};